import React from 'react';
import moment from 'moment';
import Calendar from './Calendar';
import { CalendarLayout, Modal, DropdownSelector } from 'hyperdb-utils';
import SeasonalPricesForm from './SeasonalPricesForm';
import SeasonalConditionsForm from './SeasonalConditionsForm';
import ModalSeasonsConflict from './ModalSeasonsConflict';
import { handleChangePrice, handleSubmitPrice, overwrite as overwritePrices, fillGaps as fillGapsPrices } from './SeasonalPricesEditor';
import { handleChangeCondition, handleSubmitCondition, overwrite as overwriteConditions, fillGaps as fillGapsConditions } from './SeasonalConditionsEditor';
import { getPricesCalendar, getConditionsCalendar, getAvailabilitiesCalendar } from './helpers';

class CalendarFieldset extends React.Component {
  constructor(props) {
    super(props);
    this.initialized = false;
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleDatesRangeSelected = this.handleDatesRangeSelected.bind(this);
    this.handlecClickPrice = this.handlecClickPrice.bind(this);
    this.handlecClickCondition = this.handlecClickCondition.bind(this);
    this.handleCloseModalPriceForm = this.handleCloseModalPriceForm.bind(this);
    this.handleCloseModalConditionForm = this.handleCloseModalConditionForm.bind(this);
    this.handleCloseModalPriceDetails = this.handleCloseModalPriceDetails.bind(this);
    this.handleCloseModalDatesSelected = this.handleCloseModalDatesSelected.bind(this);
    this.handleChooseAction = this.handleChooseAction.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeSeasonsalPrices = this.changeSeasonsalPrices.bind(this);
    this.changeSeasonsalConditions = this.changeSeasonsalConditions.bind(this);
    const today = moment();
    this.state = {
      selectedYear: today.year(),
      selectedMonth: today.month(),
      selectedDay: today.date(),
    };
  }
  componentWillReceiveProps(nextProps) {
    // Close modal
    if (this.state.showModalDatesSelected) {
      const pricesSaved = JSON.stringify(nextProps.objectData.seasonal_prices) !== JSON.stringify(this.props.objectData.seasonal_prices);
      const conditionsSaved = JSON.stringify(nextProps.objectData.seasonal_conditions) !== JSON.stringify(this.props.objectData.seasonal_conditions);
      if (pricesSaved || conditionsSaved) {
        this.handleCloseModalDatesSelected();
      }
    }
  }
  render() {
    const { selectedYear, selectedMonth, selectedDay } = this.state;
    const calendarDates = this.getListDates({ year: selectedYear, month: selectedMonth, day: selectedDay });
    const from = calendarDates[0].stringISO;
    const to = calendarDates.slice(-1)[0].stringISO;
    const property = this.props.property;

    return (
      <fieldset>
        <CalendarLayout
          minYear={ moment().subtract(1, 'year').format('YYYY') }
          maxYear={ moment().add(1, 'year').format('YYYY') }
          year={ selectedYear }
          month={ selectedMonth }
          day={ selectedDay }
          calendarDates={ calendarDates }
          onChangeDate={ this.handleChangeDate }
          onDatesRangeSelected={ this.handleDatesRangeSelected }
        >
          <Calendar
            prices={ this.getPrices(from, to) }
            conditions={ this.getConditions(from, to) }
            availabilities={ this.getAvailabilities(from, to) }
            oncClickPrice={ this.handlecClickPrice }
            onClickCondition={ this.handlecClickCondition } />
        </CalendarLayout>
        {
          this.state.showModalPrice
            ? <Modal title="Price details" onClose={ this.handleCloseModalPriceDetails } labelCancel="Close">
                <div className="row info-price">
                  <div className="pull-left labels">
                    <h5>date :</h5>
                    <h5>min. nights :</h5>
                    <h5>nb. guests :</h5>
                    <h5>price :</h5>
                  </div>
                  <div>
                    <h5>{ this.state.priceDetails.date }&nbsp;</h5>
                    <h5>{ this.state.priceDetails.min_nights }&nbsp;</h5>
                    <h5>{ this.state.priceDetails.nb_guests }&nbsp;</h5>
                    <h5>{ this.state.priceDetails.price }&nbsp;</h5>
                  </div>
                  </div>
              </Modal>
            : null
        }
        {
          this.state.showModalDatesSelected
            ? <Modal title="Selected dates" onClose={ this.handleCloseModalDatesSelected } onAccept={ this.handleSubmit }>
                <DropdownSelector
                  placeholder="Select an action"
                  name="action"
                  value={ this.state.actionDatesSelected }
                  options={ this.actionsOptions() }
                  onChange={ this.handleChooseAction }
                />
                {
                  this.state.actionDatesSelected === 'price'
                    ? <SeasonalPricesForm
                        property={ property }
                        seasonalPrice={ this.state.editedSeasonalPrice }
                        onChange={ handleChangePrice.bind(this) }
                        errorDates={ this.state.errorDates }
                      />
                    : null
                }
                {
                  this.state.actionDatesSelected === 'condition'
                    ? <SeasonalConditionsForm
                        seasonalCondition={ this.state.editedSeasonalCondition }
                        onChange={ handleChangeCondition.bind(this) }
                        errorDates={ this.state.errorDates }
                      />
                    : null
                }
              </Modal>
            : null
        }
        {
          this.state.showModalSeasonalPricesForm
            ? <Modal title="Seasonal price" onClose={ this.handleCloseModalPriceForm } onAccept={ this.handleSubmit.bind(this, 'price') }>
                <SeasonalPricesForm
                  property={ property }
                  seasonalPrice={ this.state.editedSeasonalPrice }
                  onChange={ handleChangePrice.bind(this) }
                  errorDates={ this.state.errorDates }
                />
              </Modal>
            : null
        }
        {
          this.state.showModalSeasonalConditionsForm
            ? <Modal title="Seasonal condition" onClose={ this.handleCloseModalConditionForm } onAccept={ this.handleSubmit.bind(this, 'condition') }>
                <SeasonalConditionsForm
                  seasonalCondition={ this.state.editedSeasonalCondition }
                  onChange={ handleChangeCondition.bind(this) }
                  errorDates={ this.state.errorDates }
                />
              </Modal>
            : null
        }
        {
          this.props.showModalConflictPrices
            ? <ModalSeasonsConflict
                close={ this.props.toggleModalConflictPrices.bind(this, false) }
                items={ this.props.prices }
                indexesSeasonsInConflict={ this.props.indexesSeasonsInConflict }
                overwrite={ overwritePrices.bind(this, this.changeSeasonsalPrices) }
                fillGaps={ fillGapsPrices.bind(this, this.changeSeasonsalPrices) }
              />
            : null
        }
        {
          this.props.showModalConflictConditions
            ? <ModalSeasonsConflict
                close={ this.props.toggleModalConflictConditions.bind(this, false) }
                items={ this.props.conditions }
                indexesSeasonsInConflict={ this.props.indexesSeasonsInConflict }
                overwrite={ overwriteConditions.bind(this, this.changeSeasonsalConditions) }
                fillGaps={ fillGapsConditions.bind(this, this.changeSeasonsalConditions) }
              />
            : null
        }
      </fieldset>
    );
  }
  getListDates({ year, month, day }) {
    const date = moment({ year, month, day });
    const isMonday = date.isoWeekday() === 1;
    const start = isMonday ? date.subtract(7, 'days') : date.startOf('isoWeek');
    const end = start.clone().add(41, 'days');
    const listDates = [];
    for (let currentDate = start; currentDate.isSameOrBefore(end); currentDate.add(1, 'days')) {
      const currentDay = this.getListDays()[currentDate.isoWeekday() - 1];
      const dateParams = { stringISO: currentDate.format('YYYY-MM-DD'), label: `${currentDay.short} ${currentDate.format('DD')}` };
      listDates.push(dateParams);
    }
    return listDates;
  }
  getListDays() {
    return [
      { name: 'Monday', short: 'Mo', value: 1 },
      { name: 'Tuesday', short: 'Tu', value: 2 },
      { name: 'Wednesday', short: 'We', value: 3 },
      { name: 'Thursday', short: 'Th', value: 4 },
      { name: 'Friday', short: 'Fr', value: 5 },
      { name: 'Saturday', short: 'Sa', value: 6 },
      { name: 'Sunday', short: 'Su', value: 7 },
    ];
  }
  getPrices(from, to) {
    const rentalRuleset = this.props.objectData;
    const property = this.props.property;
    if (rentalRuleset && property) {
      const standard_capacity = property.standard_capacity;
      const maximum_capacity = property.maximum_capacity;
      return getPricesCalendar(rentalRuleset, { standard_capacity, maximum_capacity, from, to });
    }
    return {};
  }
  getConditions(from, to) {
    const rentalRuleset = this.props.objectData;
    if (rentalRuleset) {
      return getConditionsCalendar(rentalRuleset, { from, to });
    }
    return [];
  }
  getAvailabilities(from, to) {
    const rentalRuleset = this.props.objectData;
    if (rentalRuleset) {
      return getAvailabilitiesCalendar(rentalRuleset.property, rentalRuleset.unitsAvailabilityDays || [], { from, to });
    }
    return {};
  }

  actionsOptions() {
    const options = [];
    const property = this.props.property;
    if (!property.source_channel || !property.source_channel.settings.receive_prices) {
      if (property.standard_capacity && property.maximum_capacity) {
        options.push({ name: 'Add seasonal price', value: 'price' });
      }
    }
    if (!property.source_channel || !property.source_channel.settings.receive_conditions) {
      options.push({ name: 'Add seasonal condition', value: 'condition' });
    }
    return options;
  }

  handleChangeDate({ year, month, day }) {
    this.setState({
      selectedYear: year,
      selectedMonth: month,
      selectedDay: day,
    });
  }
  handleDatesRangeSelected(dates) {
    this.setState({
      showModalDatesSelected: true,
      editedSeasonalPrice: { date_start: dates[0], date_end: dates[1] },
      editedSeasonalCondition: { date_start: dates[0], date_end: dates[1] },
      actionDatesSelected: '',
    });
  }
  handleCloseModalDatesSelected() {
    this.setState({
      showModalDatesSelected: false,
      editedSeasonalPrice: {},
      editedSeasonalCondition: {},
      actionDatesSelected: '',
    });
  }
  handleChooseAction(field) {
    const { name, value } = field;
    this.setState({ actionDatesSelected: value });
  }
  handleSubmit(action = null) {
    const _action = this.state.actionDatesSelected || action;
    if (_action === 'price') {
      handleSubmitPrice.bind(this)(this.changeSeasonsalPrices, true);
      if (this.props.onPricesAndConditionsChanged) this.props.onPricesAndConditionsChanged();
    } else if (_action === 'condition') {
      handleSubmitCondition.bind(this)(this.changeSeasonsalConditions, true);
      if (this.props.onPricesAndConditionsChanged) this.props.onPricesAndConditionsChanged();
    }
  }
  changeSeasonsalPrices(field) {
    this.props.onChange('prices', 'seasonal_prices', field);
  }
  changeSeasonsalConditions(field) {
    this.props.onChange('prices', 'seasonal_conditions', field);
  }

  handlecClickPrice(priceDetails) {
    if (priceDetails.display_type === 'base') {
      this.setState({
        showModalPrice: true,
        priceDetails: priceDetails,
      });
    } else {
      const indexEditedSeasonalPrice = this.props.objectData.seasonal_prices.findIndex(price => price.date_start === priceDetails.seasonStart);
      const editedSeasonalPrice = { ...this.props.objectData.seasonal_prices[indexEditedSeasonalPrice] };
      this.setState({ showModalSeasonalPricesForm: true, indexEditedSeasonalPrice, editedSeasonalPrice, errorDates: false });
    }
  }
  handleCloseModalPriceForm() {
    this.setState({
      showModalSeasonalPricesForm: false,
      indexEditedSeasonalPrice: -1,
      editedSeasonalPrice: {},
    });
  }
  handleCloseModalPriceDetails() {
    this.setState({
      showModalPrice: false,
      priceDetails: {},
    });
  }
  handlecClickCondition(condition) {
    const indexEditedSeasonalCondition = this.props.objectData.seasonal_conditions.findIndex(cond => cond.date_start === condition.seasonStart);
    const editedSeasonalCondition = { ...this.props.objectData.seasonal_conditions[indexEditedSeasonalCondition] };
    this.setState({ showModalSeasonalConditionsForm: true, indexEditedSeasonalCondition, editedSeasonalCondition, errorDates: false });
  }
  handleCloseModalConditionForm() {
    this.setState({
      showModalSeasonalConditionsForm: false,
      indexEditedSeasonalCondition: -1,
      editedSeasonalCondition: {},
    });
  }
}

export default CalendarFieldset;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/CalendarFieldset.jsx